import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./PromotedShops.css";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTranslation } from "../../hooks/useTranslation";
import { translateUI } from "../../util/dataTranslation";

class PromotedShopsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      homePromotedShops: [],
      interval: "",
      mover: 0,
      current: 0,
      slider_width: "0",
      side: "",
    };
  }
  componentDidMount() {
    axios
      .get(window.ajaxLink + "user/promotedShops")
      .then((res) => {
        this.setState({
          homePromotedShops: res["data"]["responseData"].promoted_shops,
          slider_width: res["data"]["responseData"].promoted_shops.length * 165,
        });
      })
      .catch((err) => {});

    this.slider();
  }
  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  slide = (e) => {
    var fullWidth = Math.min(window.innerWidth, 1170);
    var mover = this.state.mover;
    var current = this.state.current;

    var change = this.state.side !== "previous" ? 1 : -1;
    var onScreen = Math.floor(fullWidth / 165);
    if (fullWidth > 780) {
      mover = mover + 165 * change;
    } else {
      mover = mover + 155 * change;
      onScreen = Math.floor(fullWidth / 155);
    }

    if (current >= this.state.homePromotedShops.length - onScreen) {
      this.setState({ current: 0, mover: 0 });
    } else {
      this.setState({ current: current + 1, mover: mover });
    }
  };

  slider = () => {
    this.interval = setInterval(this.slide, 2000);
    this.setState({
      interval: this.interval,
    });
  };

  pause = () => {
    clearInterval(this.state.interval);
  };

  resume = () => {
    this.setState({ side: "" }, () => {
      this.slider();
    });
  };

  next = () => {
    var side = "";
    this.setState(
      {
        side: side,
      },
      () => {
        this.slide();
      }
    );
    clearInterval(this.state.interval);
  };

  path = (path) => {
    return this.props.getPathWithLanguage ? this.props.getPathWithLanguage(path, this.props.currentLanguage) : path;
  };

  previous = () => {
    var side = "previous";
    this.setState(
      {
        side: side,
      },
      () => {
        this.slide();
      }
    );

    clearInterval(this.state.interval);
  };

  render() {
    return (
      <div
        style={{
          borderBottom: "10px solid #f3f3f3",
        }}
      >
        <div
          className="promoted_card_and_title_container p_rel"
          onMouseEnter={this.pause}
          onMouseLeave={this.resume}
        >
          <div className="homepage_card_title_container">
            <h2 className="homepage_card_title">{this.props.t ? this.props.t('home.popularShops') : translateUI('Popularne Radnje', this.props.currentLanguage)}</h2>
          </div>
          <div
            className="slider"
            style={{
              transform: "translate3d(-" + this.state.mover + "px, 0, 0)",
              width: this.state.slider_width + "px",
            }}
          >
            <div className="homepage_card_container ">
              {this.state.homePromotedShops.map((oneItem, i) => (
                <div className="homepage_card slider_card" key={i}>
                  <Link
                    to={this.path("/radnja/" + oneItem.username)}
                    aria-label={oneItem.username ? "Radnja " + oneItem.username : "Pogledaj radnju"}
                  >
                    <div
                      className="homepage_card_image slider_card_image "
                      style={{
                        backgroundImage: oneItem.image
                          ? "url(" + oneItem.image + ")"
                          : "",
                      }}
                    ></div>
                  </Link>
                  <Link to={this.path("/radnja/" + oneItem.username)}>
                    <div className="homepage_card_description">
                      {oneItem.username}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="slider_btn slider_btn_left" onClick={this.previous}>
            &lt;
          </div>
          <div className=" slider_btn slider_btn_right" onClick={this.next}>
            &gt;
          </div>
        </div>
      </div>
    );
  }
}

// Wrapper component with hooks
const PromotedShops = (props) => {
  const { currentLanguage, getPathWithLanguage } = useLanguage();
  const { t } = useTranslation();

  return (
    <PromotedShopsComponent 
      {...props} 
      currentLanguage={currentLanguage}
      getPathWithLanguage={getPathWithLanguage}
      t={t}
    />
  );
};

export default PromotedShops;
